/**
 * Web app onboarding — phone authentication callable.
 *
 * Also used by the `/bnpl/course-payment/test` harness (ERS-25) to sign in as the patient under
 * test, so the BNPL course-payment callables see the same `request.auth.uid === signedUpPatientId`
 * a real onboarding session carries.
 */

import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../firebaseConfig';

type AuthInput = {
  signedUpPatientId: string;
  phone: string;
};

type AuthOutput = {
  token: string;
  patientFirstName: string;
  patientLastName: string;
};

export const webAppOnboardingAuthentication = (data: AuthInput) =>
  httpsCallable<AuthInput, AuthOutput>(functions, 'webAppOnboardingAuthentication')(data).then((r) => r.data);
